import dateUtils from '../../../_helpers/dateUtils'

const DateTime = (path) => (rowData) =>
  rowData[path] ? dateUtils.formatDateTime(rowData[path]) : ''
export default DateTime
